import React, { useEffect, useState } from 'react';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { getLocations, LocationOption } from '../api';
import { useLocationFilter } from '../hooks/useLocationFilter';

// State and District dropdowns. "Near me" (no state) lists places around the visitor's location;
// a state lists every venue there. Only states and districts that have venues are offered.
const LocationFilter: React.FC = () => {
  const { area, setArea } = useLocationFilter();
  const [options, setOptions] = useState<LocationOption[]>([]);

  useEffect(() => {
    getLocations().then(setOptions).catch(() => setOptions([]));
  }, []);

  // Keep a remembered choice selectable even if the list hasn't loaded or no longer has it.
  const states = options.some((o) => o.state === area.state) || !area.state ? options : [...options, { state: area.state, districts: [] }];
  const districts = states.find((o) => o.state === area.state)?.districts ?? [];
  const districtList = area.district && !districts.includes(area.district) ? [...districts, area.district] : districts;

  return (
    <div className="location-filter" role="group" aria-label="Location">
      <LocationOnOutlinedIcon className="location-filter-icon" />
      <label>
        <span>State</span>
        <select className="input" value={area.state ?? ''} onChange={(e) => setArea({ state: e.target.value || null, district: null })}>
          <option value="">Near me</option>
          {states.map((o) => <option key={o.state} value={o.state}>{o.state}</option>)}
        </select>
      </label>
      <label>
        <span>District</span>
        <select className="input" value={area.district ?? ''} disabled={!area.state} onChange={(e) => setArea({ state: area.state, district: e.target.value || null })}>
          <option value="">{area.state ? 'All districts' : '—'}</option>
          {districtList.map((d) => <option key={d} value={d}>{d}</option>)}
        </select>
      </label>
      {area.state && <button type="button" className="btn btn-dark location-filter-clear" onClick={() => setArea({})}>Near me</button>}
    </div>
  );
};

export default LocationFilter;
